var __rspack_ns_object = {"jq":"#FFBA30"}